import React, { useEffect, useState, useRef } from "react";
import {
  listenMessages,
  markAsRead,
} from "../services/chatService";
import MessageItem from "./MessageItem";
import MessageInput from "./MessageInput";

const ChatWindow = ({ me, partner }) => {
  const [messages, setMessages] = useState([]);
  const bottomRef = useRef(null);

  useEffect(() => {
  if (!partner?.id || !me?.id) return;

  let unsubscribeFn = () => {};

  const listen = async () => {
    unsubscribeFn = await listenMessages(me.id, partner.id, (snap) => {
      const arr = [];
      snap.forEach((doc) => arr.push({ id: doc.id, ...doc.data() }));

      arr.sort((a, b) => {
        if (!a.createdAt || !b.createdAt) return 0;
        return a.createdAt.toMillis() - b.createdAt.toMillis();
      });

      setMessages(arr);

      // ✅ Mark messages as read after loading
      markAsRead(me.id, partner.id);

      setTimeout(() => {
              bottomRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "end",
              });
      }, 50);
    });
  };

  listen();

  return () => {
    if (typeof unsubscribeFn === "function") unsubscribeFn();
  };
}, [me.id, partner.id]);



  return (
    <div style={styles.container}>
      
      {/* HEADER */}
      <div style={styles.header}>
        <img
          src={partner.image || "/default-avatar.png"}
          style={styles.avatar}
          alt="user"
        />
        <div>
          <b>{partner.name}</b>
          <div style={{ fontSize: 12 }}>
            {partner?.is_online ? "Online" : "Offline"}
          </div>
        </div>
      </div>

      {/* MESSAGES */}
      <div style={styles.messages}>
        {messages.map((msg) => (
          <MessageItem key={msg.id} msg={msg} me={me.id} />
        ))}

        <div ref={bottomRef}></div>
      </div>

      {/* INPUT */}
      <MessageInput me={me} partner={partner} />
    </div>
  );
};

const styles = {
  container: {
    width: "400px",
    border: "1px solid #ccc",
    display: "flex",
    flexDirection: "column",
    height: "570px",
    background: "#fff",
  },
  header: {
    display: "flex",
    alignItems: "center",
    padding: "12px",
    borderBottom: "1px solid #ddd",
    background: "#f9f9f9",
  },
  avatar: {
    width: 42,
    height: 42,
    borderRadius: "50%",
    marginRight: 12,
  },
  messages: {
    flex: 1,
    overflowY: "auto",
    padding: "12px",
    background: "#f0f0f0",
  },
};

export default ChatWindow;
